import type { ReportProvider, ReportFilter, ReportDataset, DatasetOptions, MetricId } from '../types'
import { engineApi } from '../../../sdk/engine.api'
import { metricsDataset } from '../engine/dataset'

const SUPPORTED_METRICS: MetricId[] = [
  'scPending', 'scAssigned', 'scConfirmedToday',
  'scNoAnswerToday', 'scPostponed',
  'scConversionRate', 'scChangesRequested', 'scAvgConfirmTime',
]

export const ShippingConfirmationReportProvider: ReportProvider = {
  id:                   'shipping_confirmation',
  label:                'Shipping Confirmation',
  workflowId:           'shipping_confirmation',
  supportedMetrics:     SUPPORTED_METRICS,
  supportedDimensions:  ['date', 'agent', 'team', 'status', 'outcome'],
  supportedFilters:     ['date_range', 'preset', 'teams', 'members', 'status'],
  supportedExports:     ['csv', 'excel', 'json', 'pdf'],
  defaultFilter:        { workflows: ['shipping_confirmation'] },

  async buildDataset(shop: string, filter: ReportFilter, options?: DatasetOptions): Promise<ReportDataset> {
    const data = await engineApi.metrics(shop, 'shipping_confirmation')

    const confirmed  = data.closedToday.byOutcome['sc_confirmed_for_shipping'] ?? 0
    const noAnswer   = data.closedToday.byOutcome['no_answer']                  ?? 0
    const changes    = (data.closedToday.byOutcome['sc_customer_requested_delay'] ?? 0)
                     + (data.closedToday.byOutcome['sc_customer_requested_change'] ?? 0)
    const closedTotal = data.closedToday.total
    const convRate   = closedTotal > 0 ? confirmed / closedTotal : 0

    const metrics: Record<string, number> = {
      scPending:          data.queued,
      scAssigned:         data.active,
      scPostponed:        data.postponed,
      scConfirmedToday:   confirmed,
      scNoAnswerToday:    noAnswer,
      scChangesRequested: changes,
      scConversionRate:   convRate,
      scAvgConfirmTime:   0,
    }

    return metricsDataset('shipping_confirmation', 'shipping_confirmation', filter, metrics, undefined, options)
  },
}
